<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM4.53431 3.83859C4.33944 3.7036 4.07001 3.72288 3.89645 3.89645L3.83859 3.96569C3.7036 4.16056 3.72288 4.42999 3.89645 4.60355L5.293 6L3.89645 7.39645L3.83859 7.46569C3.7036 7.66056 3.72288 7.92999 3.89645 8.10355L3.96569 8.16141C4.16056 8.2964 4.42999 8.27712 4.60355 8.10355L6 6.707L7.39645 8.10355L7.46569 8.16141C7.66056 8.2964 7.92999 8.27712 8.10355 8.10355L8.16141 8.03431C8.2964 7.83944 8.27712 7.57001 8.10355 7.39645L6.707 6L8.10355 4.60355L8.16141 4.53431C8.2964 4.33944 8.27712 4.07001 8.10355 3.89645L8.03431 3.83859C7.83944 3.7036 7.57001 3.72288 7.39645 3.89645L6 5.293L4.60355 3.89645L4.53431 3.83859Z" />
  </svg>
</template>
